module.exports = __webpack_public_path__ + "media/images/webpage/coupons/sp-cover-34d5b449ad91d24c88065f409c5729a2.webp";